import React from 'react';
// Eliminamos las importaciones de date-fns
// import { format } from 'date-fns';
// import { es } from 'date-fns/locale';

const FileList = ({ files, onRenameClick, onNavigate, onDeleteClick, onPreviewImage, onDownloadFile }) => {

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  const isImage = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff'];
    return imageExtensions.includes(extension);
  };

  // --- NUEVA FUNCIÓN PARA FORMATO DE FECHA SIN LIBRERÍAS ---
  const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);

    // Opciones para un formato legible en español
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Formato de 24 horas
    };

    // Usar toLocaleString para obtener el formato local
    // 'es-ES' para español de España, puedes usar 'es-MX' para México, etc.
    return date.toLocaleString('es-ES', options);
  };
  // --- FIN DE LA NUEVA FUNCIÓN ---

  return (
    <div className="file-list-container">
      <div className="file-list-header">
        <span></span> {/* Para el icono */}
        <span>Nombre</span>
        <span>Tipo</span>
        <span style={{ textAlign: 'right' }}>Tamaño</span>
        <span>Última Modificación</span>
        <span>Acciones</span>
      </div>
      <ul className="file-list">
        {files.map((file) => (
          <li key={file.path || file.name} className="file-item"
              // onClick={() => file.isDirectory ? onNavigate(file.path) : onDownloadFile(file.path, file.name)}
              onClick={() => file.isDirectory ? onNavigate(file.path) :''}
          >
            <div className="file-item-info">
              {file.name === '..' ? (
                <span className="folder-icon">⬆️</span> // Icono para "subir"
              ) : file.isDirectory ? (
                <span className="folder-icon">📁</span>
              ) : isImage(file.name) ? (
                <span className="image-icon">🖼️</span>
              ) : (
                <span className="file-icon">📄</span>
              )}
              <span className="file-name">{file.name}</span>
            </div>
            <span className="file-type">
              {file.name === '..' ? 'Parent Directory' : file.isDirectory ? 'Carpeta' : file.name.split('.').pop().toUpperCase()}
            </span>
            <span className="file-size">{file.isFile && file.size !== null ? formatBytes(file.size) : ''}</span>
            <span className="file-modified">
              {/* Usamos la nueva función para formatear la fecha */}
              {file.lastModified ? formatDateTime(file.lastModified) : ''}
            </span>
            <div className="file-actions" onClick={(e) => e.stopPropagation()}>
              {!file.isDirectory && isImage(file.name) && (
                <button className="action-button preview" onClick={() => onPreviewImage(file.path)}>Previsualizar</button>
              )}
              {!file.isDirectory && (
                <button className="action-button download" onClick={() => onDownloadFile(file.path, file.name)}>Descargar</button>
              )}
              {file.name !== '..' && !file.isDirectory && ( // Solo archivos se pueden renombrar
                <button className="action-button rename" onClick={() => onRenameClick(file.name)}>Renombrar</button>
              )}
              {file.name !== '..' && !file.isDirectory && ( // Solo archivos se pueden eliminar
                <button className="action-button delete" onClick={() => onDeleteClick(file.name)}>Eliminar</button>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FileList;